module.exports = __webpack_public_path__ + "static/alaide-75d947affccbecb7bb095aabc59a5aac.jpg";